import FormatNumber from 'modules/format/number';
import SelectColor from 'modules/format/selectColor';
import RequiredValidation from 'modules/validation/requiredValidation';
import PostalCodeValidation from 'modules/validation/postalCodeValidation';
import DisabledHandler from 'modules/validation/disabledHandler';
import DomainSuggest from 'modules/email/domainSuggest';
import FormatMask from 'modules/format/formatMask';
import SquareMeterValidation, { MIN_SQUARE_METER_FOCUS_AREA, MIN_SQUARE_METER_DEFAULT } from 'modules/validation/squareMeterValidation';
import SelectDefault from 'modules/form/selectDefault';
import PhoneValidation from 'modules/validation/phoneValidation';
import ApartmentNameCompletion from 'modules/completion/apartmentNameCompletion';

const formatNumber = new FormatNumber();
const selectColor = new SelectColor();
const required = new RequiredValidation();
const postalCodeValidation = new PostalCodeValidation('kaitori', true);
const disabledHandler = new DisabledHandler();
const domainSuggest = new DomainSuggest();
const formatMask = new FormatMask();
const squareMeterValidation = new SquareMeterValidation();
const layoutTargets = document.getElementsByClassName('js-layout') as HTMLCollectionOf<HTMLSelectElement>;
const defaultValue = 'two_ldk_sldk';
const selectDefault = new SelectDefault(layoutTargets, defaultValue);
const phoneValidation = new PhoneValidation();
const apartmentNameCompletion = new ApartmentNameCompletion();

// 数字フォーマット
formatNumber.onChange();
// セレクトの文字色
selectColor.onChange();
selectColor.onLoad();
// セレクトのデフォルト値
selectDefault.onFocus();
// 必須項目バリデーション
required.validate();
// 郵便番号バリデーション
postalCodeValidation.validate();
postalCodeValidation.focus();
postalCodeValidation.setOnFocusAreaChange((isFocusArea) => {
  squareMeterValidation.setMinSquareMeter(isFocusArea ? MIN_SQUARE_METER_FOCUS_AREA : MIN_SQUARE_METER_DEFAULT);
});
// 部屋の広さのバリデーション
squareMeterValidation.validate();
// 面積フィールドのblur時にエリア判定を最新化
postalCodeValidation.bindSquareMeterBlur();
// submitボタンクリッカブル操作
disabledHandler.validate();
// メールアドレスのドメインの入力補助
domainSuggest.enableSuggestion();
// 郵便番号の入力補助
formatMask.maskPostalCode();
// 電話番号バリデーション
phoneValidation.validate();
// 物件名の自動補完
apartmentNameCompletion.enableCompletion();
